const impactBenefit1 = {
    number: "1/3",
    question: "Impact/Benefit",
    description: `What kind of benefit did the people you served get from you?`
}

const impactBenefit2 = {
    number: "2/3",
    question: "Impact/Benefit",
    description: "Do you expect to bring the same benefit moving forward? If not, add the new benefits to the list."
}

const combine = {
    number: "3/3",
    question: "Combine",
    description: `In a single phrase, write the benefits that the people you help will get. You can combine info from both columns.
                            Answer: What is the main benefit people will get from your work?`
}

export const questions = {
    impactBenefit1: impactBenefit1,
    impactBenefit2: impactBenefit2,
    combine: combine,
}

const impactBenefit1Video = {
    url: "https://www.dropbox.com/scl/fi/qrz00trtupp5mmvax59iu/11-The-Benefit.mp4?rlkey=7hmvuttmkt5vv640ooqdzwmai&raw=1"
}

const impactBenefit2Video = {
    url: "https://www.dropbox.com/scl/fi/si86i74ne8k9ye80p3itt/12-The-Future-Benefit.mp4?rlkey=nr67rsg76oo74aou8ysxdrfo6&raw=1"
}

const combineVideo = {
    url: "https://www.dropbox.com/scl/fi/t1xwiwaecj765gyo6pybf/13-Combine.mp4?rlkey=ltkk7rgvwai8urrwzc1ze4q4m&raw=1"
}
export const videos = {
    impactBenefit1Video: impactBenefit1Video,
    impactBenefit2Video: impactBenefit2Video,
    combineVideo: combineVideo,
}